import { InformationTooltip, UIText1 } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';
import { IBuilder, ISpecificationItem } from '../../types/newbuildingSpecifications';
import { Link } from '../Link';

export const NewbuildingSpecifications = ({
  specifications,
  status,
  developer,
  brochure,
}: {
  specifications: ISpecificationItem[];
  status: string;
  developer: IBuilder | null;
  brochure: React.ReactNode;
}) => {
  return (
    <ul className={styles['container']}>
      <li className={styles['item']}>
        <div className={styles['title']}>
          <UIText1 color="gray60_100">Сдача комплекса</UIText1>
        </div>
        <UIText1>{status}</UIText1>
      </li>
      {developer && developer.url && (
        <li className={styles['item']}>
          <div className={styles['title']}>
            <UIText1 color="gray60_100">Застройщик</UIText1>{' '}
          </div>
          <Link target="_blank" url={developer.url}>
            {developer.name}
          </Link>
        </li>
      )}
      {specifications.map(item => (
        <li key={item.title} className={styles['item']}>
          <div className={styles['title']}>
            <UIText1 color="gray60_100">{item.title}</UIText1>
          </div>
          <UIText1>{item.value || '-'}</UIText1>
          {item.valueTooltipText && (
            <InformationTooltip header={item.value} content={item.valueTooltipText} theme="white">
              <div className={styles['faq']} data-testid="NewbuildingSpecificationFaqIcon">
                <Faq16 color="primary_100" />
              </div>
            </InformationTooltip>
          )}
        </li>
      ))}
      {brochure && <li className={styles['item']}>{brochure}</li>}
    </ul>
  );
};
